import {WebsiteLinkData} from "../types/mb-website-links-modal.types";

export const defaultWebsiteLinksData: WebsiteLinkData = {
  id: 0,
  link: '',
  history: []
}
